import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as Settings } from 'Assets/controls/settings.svg';
import { FilterItemProps } from 'Components/PageTable/PageTable';
import styled from './FilterMenuWrapper.module.scss';

type FilterMenuWrapperProps = {
  name: string;
  item: React.FC<FilterItemProps>;
};

const FilterMenuWrapper: React.FC<FilterMenuWrapperProps> = ({
  name,
  item,
}) => {
  const Item = item;
  const [itemState, setItemState] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const toggleOpenState = () => {
    setItemState((prevState) => !prevState);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setItemState(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styled.filter} ref={ref}>
      {name}
      <Settings onClick={toggleOpenState} />
      {itemState && <Item openStateToggler={toggleOpenState} />}
    </div>
  );
};

export default FilterMenuWrapper;
